import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const SkeletonStrutturaCard = () => (
  <div className="col-12 col-md-6 col-lg-4 mb-4">
    <div className="card listing-item shadow">
      <div className="strutture-title my-4 position-relative d-flex align-items-center px-2">
        <div className="position-absolute strutture-logo">
          <Skeleton circle={true} height={40} width={40} />
        </div>
        <h5 className="mb-0 strutture-name py-2 fs-4 lh-1 d-flex align-items-center w-100">
          <Skeleton width={`80%`} height={24} />
        </h5>
      </div>
      <div className="strutture-info px-2">
        <div className="mail sitoweb d-flex align-items-center mb-2">
          <Skeleton width={200} height={16} />
        </div>
        <div className="sitoweb d-flex align-items-center">
          <Skeleton width={180} height={16} />
        </div>
      </div>
      <div className="strutture-link-container d-flex justify-content-end p-2">
        <Skeleton width={100} height={20} />
      </div>
    </div>
  </div>
);

const BlockSearchStruttureBodySkeleton = () => (
  <div className="public-ui searchStrutture">
    <div className="ui container">
      <div className="searchContainer d-flex w-100 mt-5 flex-column">
        <h3 className="search-strutture-title text-primary">
          <Skeleton width={300} height={30} />
        </h3>
        <div className="searchbar shadow-sm d-flex w-100">
          <div className="rounded-start d-flex align-items-center px-3">
            <Skeleton circle={true} width={24} height={24} />
          </div>
          <Skeleton className="flex-grow-1 rounded-end" height={40} />
        </div>
      </div>
      <div className="mt-4">
        <Skeleton width={200} height={20} className="mb-2" />
        <Skeleton width={150} height={20} className="mb-3" />
      </div>
      <div className="row mt-4">
        {Array.from({ length: 18 }).map((_, i) => (
          <SkeletonStrutturaCard key={i} />
        ))}
      </div>
    </div>
  </div>
);

export default BlockSearchStruttureBodySkeleton;
